module.exports = __webpack_public_path__ + "static/media/kyc_status_icon.e925fb90.svg";